import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import RadioButton from '../../RadioButton/RadioButton';

const SortEngine = (props) => {
  const { columns, data, setSortData } = props;

  const onChange = (e) => {
    const newData = Object.assign({}, data);
    newData[e.target.name] = e.target.value;

    setSortData(newData);
  };

  return (
    <div id="sort-by-column-filter">
      <Input
        name="sortColumn"
        type="select"
        className="advanced-filter-select"
        bsSize="sm"
        value={data.sortColumn}
        onChange={onChange}>
        <option value="">Coluna...</option>
        {
          columns.map((col, index) => {
            return (
              <option key={`SortOption_${index}`} value={col.value}>{col.label}</option>
            );
          })
        }
      </Input>
      <RadioButton
        option1={{ value: 'asc', checked: data.sortDirection === 'asc' }}
        option2={{ value: 'desc', checked: data.sortDirection === 'desc' }}
        name='sortDirection'
        onChange={onChange} />
    </div>
  );
};

SortEngine.propTypes = {
  data: PropTypes.object.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  setSortData: PropTypes.func.isRequired
};

export default SortEngine;